import React from 'react';

const RegisterHeader = () => {
    return (
        <div>
            <h1>Register</h1>
        </div>
    );
};

export default RegisterHeader;
